<template>
  <v-expand-transition>
    <div v-if="visible" class="portal-banner" :class="themeClass" role="alert" aria-live="polite">
      <v-icon class="portal-banner__icon" :color="iconColor" size="20">{{ icon }}</v-icon>
      <div class="portal-banner__content">
        <div class="portal-banner__text">{{ text }}</div>
      </div>
      <v-btn
        icon
        class="portal-banner__close"
        :aria-label="'Dismiss notification'"
        @click="$emit('dismiss')"
      >
        <v-icon :color="iconColor" size="18">mdi-close</v-icon>
      </v-btn>
    </div>
  </v-expand-transition>
</template>

<script>
export default {
  name: 'PortalBanner',
  props: {
    notification: {
      type: Object,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    type() {
      const t = this.notification && this.notification.notificationType;
      return t ? String(t).toLowerCase() : 'info';
    },
    text() {
      return (this.notification && this.notification.text) || '';
    },
    icon() {
      if (this.type === 'critical') return 'mdi-alert-circle';
      if (this.type === 'warning') return 'mdi-alert';
      return 'mdi-information';
    },
    iconColor() {
      if (this.type === 'critical') return '#b71c1c';
      if (this.type === 'warning') return '#8a6d00';
      return '#0d47a1';
    },
    themeClass() {
      if (this.type === 'critical') return 'portal-banner--critical';
      if (this.type === 'warning') return 'portal-banner--warning';
      return 'portal-banner--info';
    },
  },
};
</script>

<style lang="scss" scoped>
.portal-banner {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.10);
}

.portal-banner__icon {
  margin-left: 2px;
}

.portal-banner__content {
  flex: 1 1 auto;
  min-width: 0;
}

.portal-banner__text {
  color: rgba(0, 0, 0, 0.87);
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  word-break: break-word;
}

.portal-banner__close {
  flex: 0 0 auto;
  margin-left: 8px;
}

.portal-banner--info {
  background: #e8f1ff;
  border-color: rgba(13, 71, 161, 0.22);
}

.portal-banner--warning {
  background: #fff6db;
  border-color: rgba(138, 109, 0, 0.25);
}

.portal-banner--critical {
  background: #ffe7e7;
  border-color: rgba(183, 28, 28, 0.22);
}
</style>
